import React from 'react'
import {  noImage,   } from '../../../../assets'

const ReturnModal = ({ children,isOpen, onClose}) => {
    if (!isOpen) return null;
  return (
    <div className='flex justify-center z-20 fixed h-full w-full top-0 right-0 items-center'>
        <div className='absolute bg-white right-[50px] top-[100px] drop-shadow-lg rounded max-w-[140px] w-full z-50 min-w-[108px] sm:max-w-[180px] md:h-auto md:right-[100px] md:top-[80px]'>
            <div>{children || (<img src={noImage} alt='no data available' />)}</div>
        </div>
        <div onClick={onClose} className=" z-40 fixed top-0 left-0 w-full h-full flex justify-center items-center "></div>
    </div>
  )
}

export default ReturnModal